var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"learning-category"}},[_c('KnowledgeBase',{staticClass:"mb-10"}),_c('IssueTracking',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }